import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import { connect } from 'react-redux';
import { CurrencyProvider } from 'dibs-buyer-layout/exports/CurrencyProvider';
import { SbRespSortItems } from '../../finding/SbRespSortItems/SbRespSortItems';
import { SbRespRefineTopAppliedFilters } from '../../finding/SbRespRefineTopNav/SbRespRefineTopAppliedFilters';
import { sortOrderLabel } from '../../shared/sharedMessages';
import { SharedFollowTopButton } from '../../shared/SharedFollowTopButton/SharedFollowTopButton';

// styles
import styles from './buyRespTopNav.scss';

function BuyRespTopNavComponent({
    buyPage: itemSearch,
    user = {},
    showFollowButton,
    followSearchValue,
    isFollowing,
    refetchFollow,
    isCategorySearch,
}) {
    return (
        <div className={styles.wrapper}>
            <CurrencyProvider
                render={({ currency }) => (
                    <>
                        <div className={styles.topSection}>
                            <SharedFollowTopButton
                                user={user}
                                showFollowButton={showFollowButton}
                                followSearchValue={followSearchValue}
                                isFollowing={isFollowing}
                                refetchFollow={refetchFollow}
                                isCategorySearch={isCategorySearch}
                                itemSearch={itemSearch}
                            />
                            <div className={styles.sortAndPriceContainer}>
                                <span className={styles.label}>{sortOrderLabel}</span>
                                <SbRespSortItems itemSearch={itemSearch} />
                            </div>
                        </div>
                        <div className={styles.middleSection}>
                            <div className={styles.appliedFiltersWrapper}>
                                <SbRespRefineTopAppliedFilters
                                    currency={currency}
                                    itemSearch={itemSearch}
                                    user={user}
                                />
                            </div>
                        </div>
                    </>
                )}
            />
        </div>
    );
}

BuyRespTopNavComponent.propTypes = {
    buyPage: PropTypes.object,
    user: PropTypes.object,
    showFollowButton: PropTypes.bool,
    followSearchValue: PropTypes.string,
    isFollowing: PropTypes.bool,
    refetchFollow: PropTypes.func,
    isCategorySearch: PropTypes.bool,
};

const mapStateToProps = ({ relayVariables }) => {
    return {
        isClient: relayVariables.variables.isClient,
    };
};

export const BuyRespTopNav = createFragmentContainer(
    connect(mapStateToProps)(BuyRespTopNavComponent),
    {
        buyPage: graphql`
            fragment BuyRespTopNav_buyPage on ItemSearchQueryConnection {
                ...SbRespRefineTopAppliedFilters_itemSearch
                ...SbRespSortItems_itemSearch
                ...useMeasurementUnit_itemSearch
                ...SharedFollowTopButton_itemSearch
            }
        `,

        user: graphql`
            fragment BuyRespTopNav_user on User {
                ...useMeasurementUnit_user
                ...SbRespRefineTopAppliedFilters_user
                ...SharedFollowTopButton_user
            }
        `,
    }
);
